import * as Yup from "yup";
export const DatadogSchema = Yup.object({
    DATADOG_IS_ENABLED: Yup.boolean().required(),
    DATADOG_SERVICE_NAME: Yup.string().required(),
    DATADOG_CLIENT_TOKEN: Yup.string().required(),
});
export function getDatadogConfig(env) {
    return {
        DATADOG_IS_ENABLED: env.REACT_APP_DATADOG_ENABLED === "true",
        DATADOG_SERVICE_NAME: env.REACT_APP_DATADOG_SERVICE_NAME,
        DATADOG_CLIENT_TOKEN: env.REACT_APP_DATADOG_CLIENT_TOKEN,
    };
}
//# sourceMappingURL=datadog.js.map